import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from 'antd';
import {Arguments} from '../common/Arguments';
import {RealtimeGetMethod} from '../common/ApiMethod';
import {handleExport} from '../common/ExportDataToExcelComponent';

const SocialOrganization = () => {
	const getApi = Arguments.host + '/society_organization/society/api!societyInformation.do';
	const corporationApi = Arguments.host + '/society_organization/home/api!organizationAndCorporation.do';
	const presidentApi = Arguments.host + '/society_organization/home/api!organizationAndMember.do';
	const shujiApi = Arguments.host + '/society_organization/home/api!branchShuji.do';
	const meetingMemberApi = Arguments.host + '/society_organization/home/api!organizationMeetingDelegate.do';
	const [data, setData] = useState([]);
	const [stData, setStData] = useState([]);
	const [mfData, setMfData] = useState([]);
	const [jjhData, setJjhData] = useState([]);

	useEffect(() => {
		// 前四个数量统计以及导出
		RealtimeGetMethod(getApi).then(allData => {
			const filteredData = allData.length > 0 ? allSocietyData(
				allData.filter(item => !item.organizationName?.includes('测试'))) : [];
			setData(filteredData);
			setStData(filteredData.filter(data => data['组织类型'] === '社会团体'));
			setMfData(filteredData.filter(data => data['组织类型'] === '社会服务机构'));
			setJjhData(filteredData.filter(data => data['组织类型'] === '基金会'));
		});
	}, [getApi]);

	// 导出总数
	const allSocietyData = (allData) => {
		return allData.map(
			(
				{
					organizationName,
					stOrMbsk,
					organizationType,
					organizationCode,
					establishUnit,
					organizationEstablishDate,
					organizationEstablishMoney,
					organizationBank,
					organizationBankAccount,
					organizationEvaluationGrade,
					organizationPublicWx,
					organizationSubdiscipline,
					organizationWorkPeopleCount,
					organizationOneTermYear,
					organizationCurrentTerm,
					organizationTermDate,
					organizationMemo,
				},
			) => (
				{
					'组织名称': organizationName,
					'类型': stOrMbsk,
					'组织类型': organizationType,
					'组织机构代码': organizationCode,
					'发起人或单位': establishUnit,
					'成立日期': organizationEstablishDate,
					'开办资金（万元）': organizationEstablishMoney,
					'开户行名称': organizationBank,
					'开户行账号': organizationBankAccount,
					'评估等级': organizationEvaluationGrade,
					'公众号': organizationPublicWx,
					'学科类别': organizationSubdiscipline,
					'从业人数': organizationWorkPeopleCount,
					'每届年限': organizationOneTermYear,
					'当前届数': organizationCurrentTerm,
					'换届日期': organizationTermDate,
					'学会简介': organizationMemo,
				}
			),
		);
	};

	// 导出法人
	const allCorporation = () => {
		return RealtimeGetMethod(corporationApi).then(allCorps => {
			return allCorps?.map(
				(
					{
						organization_name,
						st_or_mbsk,
						corporation_name,
						corporation_born,
						corporation_zzmm,
						corporation_unit,
						corporation_post,
						corporation_phone,
						corporation_card_id,
						corporation_is_fulltime,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'类型': st_or_mbsk,
							'姓名': corporation_name,
							'出生日期': corporation_born,
							'政治面貌': corporation_zzmm,
							'工作单位': corporation_unit,
							'学会职务': corporation_post,
							'联系电话': corporation_phone,
							'身份证号': corporation_card_id,
							'是否专职': corporation_is_fulltime,
						}
					),
			);
		});
	};

	const socCorporation = () => {
		allCorporation().then(allData => handleExport(allData));
	};

	const otherCorporation = (type) => {
		allCorporation().then(allData => {
			const filteredData = allData?.filter(data => data['类型'] === type);
			handleExport(filteredData);
		});
	};

	// 导出会长、副会长、秘书长
	const allPresident = () => {
		return RealtimeGetMethod(presidentApi).then(allCorps => {
			return allCorps?.map(
				(
					{
						organization_name,
						st_or_mbsk,
						member_name,
						member_born,
						member_jg,
						member_zzmm,
						member_educational,
						member_special,
						organization_post,
						member_unit,
						member_unit_attribute,
						member_post,
						member_professional,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'类型': st_or_mbsk,
							'姓名': member_name,
							'出生日期': member_born,
							'籍贯': member_jg,
							'政治面貌': member_zzmm,
							'学历': member_educational,
							'特殊人才': member_special,
							'社团职务': organization_post,
							'工作单位': member_unit,
							'单位性质': member_unit_attribute,
							'职务': member_post,
							'职称': member_professional,
						}
					),
			);
		});
	};

	const socPresident = (post) => {
		allPresident().then(allData => {
			let filteredData = [];
			if (post === '会长') {
				filteredData = allData?.filter(
					data => data['社团职务']?.includes('会长') && !data['社团职务']?.includes('副会长'));
			} else if (post === '秘书长') {
				filteredData = allData?.filter(
					data => data['社团职务']?.includes('秘书长') && !data['社团职务']?.includes('副秘书长'));
			} else {
				filteredData = allData?.filter(data => data['社团职务']?.includes(post));
			}
			handleExport(filteredData);
		});
	};

	const otherPresident = (post, type) => {
		allPresident().then(allData => {
			let filteredData = [];
			if (post === '会长') {
				filteredData = allData?.filter(data => data['社团职务']?.includes('会长') &&
					!data['社团职务']?.includes('副会长') && data['类型'] === type);
			} else if (post === '秘书长') {
				filteredData = allData?.filter(data => data['社团职务']?.includes('秘书长') &&
					!data['社团职务']?.includes('副秘书长') && data['类型'] === type);
			} else {
				filteredData = allData?.filter(data => data['社团职务']?.includes(post) &&
					data['类型'] === type);
			}
			handleExport(filteredData);
		});
	};

	// 导出书记
	const allShuji = () => {
		return RealtimeGetMethod(shujiApi).then(allCorps => {
			return allCorps?.map(
				(
					{
						organization_name,
						st_or_mbsk,
						party_member_name,
						party_member_born,
						party_member_unit,
						party_member_date,
						party_member_xue_li,
						party_zhi_wu,
						organization_zhi_wu,
						party_member_zzgx_unit,
						zhi_wu,
						zhi_cheng,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'类型': st_or_mbsk,
							'姓名': party_member_name,
							'出生日期': party_member_born,
							'工作单位或原单位': party_member_unit,
							'入党日期': party_member_date,
							'学历': party_member_xue_li,
							'党内职务': party_zhi_wu,
							'学会内职务': organization_zhi_wu,
							'组织关系所在单位': party_member_zzgx_unit,
							'职务': zhi_wu,
							'职称': zhi_cheng,
						}
					),
			);
		});
	};

	const socShuji = () => {
		allShuji().then(allData => {
			const filteredData = allData?.filter(data => data['党内职务']?.includes('书记') &&
				!data['党内职务']?.includes('副书记'));
			handleExport(filteredData);
		});
	};

	const otherShuji = (type) => {
		allShuji().then(allData => {
			const filteredData = allData?.filter(data => data['党内职务']?.includes('书记') &&
				!data['党内职务']?.includes('副书记') && data['类型'] === type);
			handleExport(filteredData);
		});
	};

	const meetingMembers = () => {
		// 导出代表大会成员
		RealtimeGetMethod(meetingMemberApi).then(allCorps => {
			const filteredData = allCorps?.map(
				(
					{
						organization_name,
						meeting_term_name,
						member_name,
						member_sex,
						member_born,
						member_mz,
						member_zzmm,
						member_educational,
						organization_post,
						member_unit,
						member_post,
						member_professional,
						meeting_member_post,
						member_sfz,
						member_mobile_phone,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'届次': meeting_term_name,
							'姓名': member_name,
							'性别': member_sex,
							'出生日期': member_born,
							'民族': member_mz,
							'政治面貌': member_zzmm,
							'文化程度': member_educational,
							'社团职务': organization_post,
							'工作单位': member_unit,
							'职务': member_post,
							'职称': member_professional,
							'大会职务': meeting_member_post,
							'身份证号': member_sfz,
							'手机号': member_mobile_phone,
						}
					),
			);
			handleExport(filteredData);
		});
	};

	return (
		<>
			<Row>
				<Col span={3} style={{
					textAlign: 'right',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>社会组织总数：</Col>
				<Col span={1} style={{
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>{data?.length}</Col>
				<Col span={20} style={{textAlign: 'left'}}>
					<Button type="link" onClick={() => handleExport(data)}>【导出】</Button>
					<Button type="link" onClick={() => socCorporation()}>【导出法人】</Button>
					<Button type="link" onClick={() => socPresident('会长')}>【导出会长】</Button>
					<Button type="link" onClick={() => socPresident('副会长')}>【导出副会长】</Button>
					<Button type="link" onClick={() => socPresident('秘书长')}>【导出秘书长】</Button>
					<Button type="link" onClick={() => socShuji()}>【导出支部书记】</Button>
					<Button type="link" onClick={() => meetingMembers()}>【导出代表大会成员】</Button>
				</Col>
			</Row>

			<Row>
				<Col span={3} style={{
					textAlign: 'right',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>社团：</Col>
				<Col span={1} style={{
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>{stData?.length}</Col>
				<Col span={20} style={{textAlign: 'left'}}>
					<Button type="link" onClick={() => handleExport(stData)}>【导出】</Button>
					<Button type="link" onClick={() => otherCorporation('社团')}>【导出法人】</Button>
					<Button type="link" onClick={() => otherPresident('会长', '社团')}>【导出会长】</Button>
					<Button type="link" onClick={() => otherPresident('副会长', '社团')}>【导出副会长】</Button>
					<Button type="link" onClick={() => otherPresident('秘书长', '社团')}>【导出秘书长】</Button>
					<Button type="link" onClick={() => otherShuji('社团')}>【导出支部书记】</Button>
				</Col>
			</Row>

			<Row>
				<Col span={3} style={{
					textAlign: 'right',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>民非：</Col>
				<Col span={1} style={{
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>{mfData?.length}</Col>
				<Col span={20} style={{textAlign: 'left'}}>
					<Button type="link" onClick={() => handleExport(mfData)}>【导出】</Button>
					<Button type="link" onClick={() => otherCorporation('民非')}>【导出法人】</Button>
					<Button type="link" onClick={() => otherPresident('会长', '民非')}>【导出会长】</Button>
					<Button type="link" onClick={() => otherPresident('副会长', '民非')}>【导出副会长】</Button>
					<Button type="link" onClick={() => otherPresident('秘书长', '民非')}>【导出秘书长】</Button>
					<Button type="link" onClick={() => otherShuji('民非')}>【导出支部书记】</Button>
				</Col>
			</Row>

			<Row>
				<Col span={3} style={{
					textAlign: 'right',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>基金会：</Col>
				<Col span={1} style={{
					textAlign: 'left',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-end',
				}}>{jjhData?.length}</Col>
				<Col span={20} style={{textAlign: 'left'}}>
					<Button type="link" onClick={() => handleExport(jjhData)}>【导出】</Button>
					<Button type="link" onClick={() => otherCorporation('基金会')}>【导出法人】</Button>
					<Button type="link" onClick={() => otherPresident('会长', '基金会')}>【导出会长】</Button>
					<Button type="link" onClick={() => otherPresident('副会长', '基金会')}>【导出副会长】</Button>
					<Button type="link" onClick={() => otherPresident('秘书长', '基金会')}>【导出秘书长】</Button>
					<Button type="link" onClick={() => otherShuji('基金会')}>【导出支部书记】</Button>
				</Col>
			</Row>
		</>
	);
};

export default SocialOrganization;
